import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';
import { HttpEndpoint } from '@/api/httpEndpoints';
import {
    LeaBankEndPoint,
    LoanApplication,
    LoanApplicationResponse,
    PricingResponse,
} from '@/api/LeaBank/leaBank.interfaces';
import {
    fakeApprovedResponse,
    fakeCancelledResponse,
    fakeDeclinedResponse,
    fakePricingResponse,
} from '@/api/LeaBank/leaBank.fake';
import { Money } from '@libs/money/money.interfaces';
import { sample } from 'lodash';
import { delay } from '@shared/utils/async';
import { consoleLog, LogColorType } from '@shared/helpers/log';
import { configBase } from '@/config/base';

const market = getCurrentMarketSpecs();
const loanApplicationPath = '/leabank/loanapplication/create';
const pricingPath = '/leabank/pricing';

const loanApplicationEndpoint = configBase.devMode.enabled
    ? loanApplicationPath
    : `${market.homePage}${loanApplicationPath}`;

const pricingEndpoint = configBase.devMode.enabled
    ? pricingPath
    : `${market.homePage}${pricingPath}`;

export class LeaBankEndpoint extends HttpEndpoint implements LeaBankEndPoint {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async CreateApplication(data: LoanApplication): Promise<LoanApplicationResponse> {
        consoleLog(LogColorType.LoanApplication, 'CreateApplication(): ', data);

        const headers = {
            Referer: market.homePage,
        };

        return await this.post(loanApplicationEndpoint, data, {
            headers,
        });
    }

    public async GetPricing(data: Money): Promise<PricingResponse> {
        consoleLog(LogColorType.LoanApplication, 'GetPricing(): ', data);

        const headers = {
            Referer: market.homePage,
        };

        return await this.post(pricingEndpoint, data, {
            headers,
        });
    }
}

export class FakeLeaBankEndPoint implements LeaBankEndPoint {
    public async CreateApplication(data: LoanApplication): Promise<LoanApplicationResponse> {
        consoleLog(LogColorType.LoanApplication, 'CreateApplication(): ', data);
        await delay(4000);
        return sample([fakeApprovedResponse, fakeDeclinedResponse, fakeCancelledResponse]);
    }

    public async GetPricing(data: Money): Promise<PricingResponse> {
        consoleLog(LogColorType.LoanApplication, 'GetPricing(): ', data);
        await delay(1000);
        return fakePricingResponse;
    }
}
